import { Environment } from '@lib/constants/environment';

/**
 * Generates HTTP headers for requests, including authentication in staging.
 *
 * @returns {Record<string, string>} - The headers object.
 */
export function customHeaders(init?: HeadersInit): Record<string, string> {
  const headers: Record<string, string> =
    init instanceof Headers
      ? Object.fromEntries(init.entries())
      : Array.isArray(init)
        ? Object.fromEntries(init)
        : { ...init };

  headers['Content-Type'] = 'application/json';

  if (process.env.ENV === Environment.staging) {
    // Encode the username:password in Base64
    const credentials = Buffer.from(
      `${process.env.USERNAME}:${process.env.PASSWORD}`,
    ).toString('base64');

    headers['Authorization'] = `Basic ${credentials}`;
  }

  return headers;
}
